<script>
    import { createEventDispatcher, onMount } from "svelte";
    import { checkPasswordComplexity } from "check-password-complexity";
    import { XCircle, CheckCircle } from "svelte-bootstrap-icons";
    import { fade } from 'svelte/transition';

    export let password;

    let dispatch = new createEventDispatcher();
    let hasUppercase = false;
    let hasSpecial = false;
    let hasLength = false;
    let passwordStatus = 'weak';

    function checkComplexity() {

        if (password == null) {
            hasUppercase = false;
            hasSpecial = false;
            hasLength = false;
            dispatch('complexity', false);
            return;
        }
        
        let cmp = checkPasswordComplexity(password);

        let status = cmp.value;

        switch(status) {
            case 'tooWeak':
                passwordStatus = 'weak';
                break;
            case 'weak':
                passwordStatus = 'weak';
                break;
            case 'medium':
                passwordStatus = 'medium';
                break;
            case 'strong':
                passwordStatus = 'strong';
                break;
        }        

        if (cmp.length >= 8) {
            hasLength = true;
        } else {
            hasLength = false;
        }

        let rules = cmp.checkedRules;

        if (rules.includes('uppercase')) {
            hasUppercase = true;
        } else {
            hasUppercase = false;
        }
        
        if (rules.includes('specialCharacter')) {
            hasSpecial = true;
        } else {
            hasSpecial = false;
        }

        if (hasLength === false) {
            dispatch('complexity', false);
            return;
        }

        if (hasUppercase === false) {
            dispatch('complexity', false);
            return;
        }

        if (hasSpecial === false) {
            dispatch('complexity', false);
            return;
        }

        dispatch('complexity', true);

    }

    onMount(() => {
        checkComplexity();
    });

    
</script>

<div class='pw-complexity-wrapper text-center'>

    {#if passwordStatus == 'weak'}

        <span class='align-middle lh-lg border border-2 border-danger rounded-3 p-1 text-bg-danger me-2 mb-1'>
            <XCircle/> Weak
        </span>

    {/if}

    {#if passwordStatus == 'medium'}

        <span class='align-middle lh-lg border border-2 border-info rounded-3 p-1 text-bg-info me-2 mb-1'>
            <CheckCircle/> Medium
        </span>

    {/if}

    {#if passwordStatus == 'strong'}

        <span class='align-middle lh-lg border border-2 border-success rounded-3 p-1 text-bg-success me-2 mb-1'>
            <CheckCircle/> Strong
        </span>

    {/if}
        
    {#if hasLength === false}

        <span class='align-middle lh-lg p-1 me-2 mb-1'>
            <XCircle/> 8 Characters
        </span>

    <!-- {:else}

        <span class='align-middle lh-lg border border-2 border-success rounded-3 p-1 text-bg-success me-2 mb-1'>
            <CheckCircle/> 8 Characters
        </span> -->

    {/if}

    {#if hasUppercase === false}

        <span class='align-middle lh-lg p-1 me-2 mb-1'>
            <XCircle/> Uppercase
        </span>

    <!-- {:else}

        <span class='align-middle lh-lg border border-2 border-success rounded-3 p-1 text-bg-success me-2 mb-1'>
            <CheckCircle/> Uppercase
        </span> -->

    {/if}

    {#if hasSpecial === false}

        <span class='align-middle lh-lg p-1 mb-1'>
            <XCircle/> Special Character
        </span>

    <!-- {:else}

        <span class='align-middle lh-lg border border-2 border-success rounded-3 p-1 text-bg-success mb-1'>
            <CheckCircle/> Special Character
        </span> -->

    {/if}

</div>
<style>
    .pw-complexity-wrapper {
        font-size: .6rem;
        line-height: .6rem;
    }
</style>